import { styled } from '@mui/material/styles';

export const RadarDegreeValueStyled = styled('text')(({ theme }) => ({
  fill: theme.palette.primary.light,
  fontSize: 16,
  letterSpacing: '0.05em',
  cursor: 'default',
}));
